import { Suspense } from "react";
import { useRoutes } from "react-router-dom";

// Routes
import routes from "./routes/appRoutes";

// Component
import GlobalLoader from "./components/layout/GlobalLoader";
import Toaster from "./components/layout/Toaster";

// Styles
import "./styles/App.scss";

// Theme variable
import React from "react";
import { setThemeVariables } from "./styles/setThemeVariables";

// Context hook provider
import { LoaderProvider } from "./hooks/useLoaderContext/useLoaderContext";
import { ToasterProvider } from "./hooks/useToasterContext/useToasterContext";
import { UserProvider } from "./hooks/useUserContext/useUserContext";

const AppRoutes = () => {
  const elements = useRoutes(routes);
  return elements;
};
const App: React.FC = () => {
  // theme variables
  React.useEffect(() => {
    setThemeVariables();
  }, []);

  return (
    <>
      <ToasterProvider>
        <LoaderProvider>
          <UserProvider>
            <Suspense fallback={<GlobalLoader />}>
              <Toaster />
              <GlobalLoader />
              <AppRoutes />
            </Suspense>
          </UserProvider>
        </LoaderProvider>
      </ToasterProvider>
    </>
  );
};

export default App;
